<template>
  <div>
    <div class="echarts" :style="`height: ${height}; min-height: 360px`" >
      <v-chart :option='options' :resizable="true" theme="infographic" :notMerge="true"></v-chart>
    </div>
  </div>
</template>

<script>
import { store } from '@/scripts/store.js'
import IEcharts from 'vue-echarts-v3/src/full.js'
import PostService from '@/scripts/post_service.js'
require ('echarts/theme/infographic')

const _ = require('lodash')

export default {
  name: 'RecentGenomesStateDistribution',
  components: {
    'v-chart': IEcharts,
  },
  data() {
    return { 
      store: store, 
      plotdata: {},
    }
  },
  props: {
    height: String,
    startDate: String,
    endDate: String,
  },
  async mounted() {
    const context = this
    context.plotdata = await PostService.getSituationData({
        plot: 'recentGenomesStateDistribution', 
        startDate: this.startDate,
        endDate: this.endDate
    })
  },
  computed: {
    options() {
      const context = this
      const plotdata = _.map(_.sortBy(context.plotdata, d => { return -1*d.count }), d => { return { name: d.state, value: d.count } })

      return {
        textStyle: {
          fontFamily: store.theme.fontFamily.content, fontSize: 14,
          fontWeight: 'bold'
        },
        tooltip: {
          trigger: 'item',
          textStyle: { fontFamily: store.theme.fontFamily.plotTooltip },
          backgroundColor: 'white'
        },
        toolbox: { 
          top: 0, right: 5, itemSize: 12,
          iconStyle: { borderColor: '#4e4e4e' },
          feature: {
            saveAsImage: { 
              title: 'Save as PNG', show: true, type: 'png', pixelRatio: 3,
              name: 'Gear19_StateDistribution', excludeComponents: ['toolbox']
            },
            dataView: { title: 'View data', readOnly: true,  lang: ['Data View', 'Go back'] },
            // magicType: { title: { stack: 'Stack/Group' }, type: ['stack'], show: true }
          }
        },
        // legend: { top: '5%', left: 'center', type: 'scroll' },
        series: [
          {
            type: 'pie', radius: ['40%', '70%'],
            avoidLabelOverlap: true,
            itemStyle: {
              borderRadius: 3, borderColor: '#fff', borderWidth: 2
            },
            label: { show: true, textBorderWidth: 0, textBorderColor: 'black' },
            labelLine: { show: true },
            data: plotdata
          }
        ]
      }
    }
  },
}
</script>

<style>
  
</style>